import { Link, makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
  card: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    margin: '4px 12px 8px',
    padding: '10px 12px',
    borderRadius: 8,
    backgroundColor: '#E1E3FF',
    color: 'var(--text-color-62, #4a4a68)',
    fontSize: 14,
    lineHeight: '20px',
    cursor: 'default'
  },
  icon: {
    flexShrink: 0,
    marginTop: 2
  },
  links: {
    marginTop: 4,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12
  },
  link: {
    color: 'var(--primary-color)',
    textDecoration: 'underline',
    fontWeight: 500
  }
})

const BoxIcon = ({ className }) => (
  <svg className={className} width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2 3 6.5v11L12 22l9-4.5v-11L12 2Z" fill="#9BA3F5" />
    <path d="M12 11 3 6.5M12 11l9-4.5M12 11v11" stroke="#fff" strokeWidth="1.2" strokeLinejoin="round" />
  </svg>
)

const ScopeShipmentCard = ({ state }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.card} id="header-menu-scope-shipment-card">
      <BoxIcon className={classes.icon} />
      <div>
        <div>{t(`common.appMenu.scopeShipment.${state.variant}`)}</div>
        {state.trackingLinks.length > 0 && (
          <div className={classes.links}>
            {state.trackingLinks.map(({ label, url }) => (
              <Link key={url} href={url} target="_blank" rel="noopener noreferrer" className={classes.link}>
                {label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default ScopeShipmentCard
